import { render, staticRenderFns } from "./TablePager.vue?vue&type=template&id=b6d99778&"
import script from "./TablePager.vue?vue&type=script&lang=js&"
export * from "./TablePager.vue?vue&type=script&lang=js&"
import style0 from "./TablePager.vue?vue&type=style&index=0&id=b6d99778&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports